import React, { Suspense } from "react";
import "./Productivity.scss";

const Marquee = React.lazy(() => import("react-fast-marquee"));
const TemplateMarq = React.lazy(() => import("./TemplateMarq"));

const Productivity = () => {
  return (
    <section className="productivity-homepage">
      <div className="productivity-text-homepage">
        <h1>Produktifitas Kegiatan Kirmago</h1>
        <p>Kegiatan ekstra dan event Kirmago yang sudah berlangsung</p>
      </div>
      <Suspense
        fallback={<div className="loading-placeholder">Loading...</div>}
      >
        <Marquee speed={30} pauseOnClick className="mark">
          <Suspense fallback={<div className="loading-placeholder" />}>
            <TemplateMarq
              src="https://telegra.ph/file/02c87e9ec3ba35e129186.jpg"
              text="Ekspedisi Pakis 2023"
              rotate="right"
            />
          </Suspense>
          <Suspense fallback={<div className="loading-placeholder" />}>
            <TemplateMarq
              src="https://telegra.ph/file/605ae379461d9f27141dc.jpg"
              text="Rapat koordinasi 2023"
              rotate="left"
            />
          </Suspense>
          <Suspense fallback={<div className="loading-placeholder" />}>
            <TemplateMarq
              src="https://telegra.ph/file/58cf9ca4d9b1db51a2041.jpg"
              text="Kunjungan KRI dr.soeharso"
              rotate="right"
            />
          </Suspense>
          <Suspense fallback={<div className="loading-placeholder" />}>
            <TemplateMarq
              src="https://telegra.ph/file/5bb5e783e99a51a3484f6.jpg"
              text="Perpisahan dengan alumni KIRMAGO 2023"
              rotate="left"
            />
          </Suspense>
        </Marquee>
      </Suspense>
    </section>
  );
};

export default Productivity;
